import React, { Suspense, useState } from "react";
import "./landingPageLayout.css";
import AiShippingSection from "./components/AiShippingSection";
import Navbar from "../components/newLandingPages/newProductPage/components/Navbar";
import ScrollToTop from "./components/ScrollToTop";
import { LandingPageRumTracker } from "../../utils/aws-app-monitor/LandingPageRumTracker";
import { usePageMeta } from "../../utils/usePageMeta";
import { useJsonLdFaq } from "../../utils/useJsonLdFaq";
import {
  PLATFORM_DEFAULT_TITLE,
  PLATFORM_META_DESCRIPTION,
} from "../../constants/platformCopy";
import HomepageSeoNav from "./components/HomepageSeoNav";
import light_curve from "../../images/Light curve.svg";

const InvestorsSection = React.lazy(
  () => import("./components/InvestorsSection"),
);
const ContinuousGovernanceSection = React.lazy(
  () => import("./components/ContinuousGovernanceSection"),
);
const GithubAppSection = React.lazy(
  () => import("./components/GithubAppSection"),
);
const VibeCodersSection = React.lazy(
  () => import("./components/VibeCodersSection"),
);
const ArchitecturalDiagrams = React.lazy(
  () => import("./components/ArchitecturalDiagrams"),
);
const InfraDiagrams = React.lazy(() => import("./components/InfraDiagrams"));
const Service = React.lazy(() => import("./components/Service"));
const SupportedTools = React.lazy(() => import("./components/SupportedTools"));
const AutoGeneratedArchitecture = React.lazy(
  () => import("./components/AutoGeneratedArchitecture"),
);
const FAQ = React.lazy(() => import("./components/FAQ"));
const SubscribeSection = React.lazy(
  () => import("./components/SubscribeSection"),
);
const Footer = React.lazy(
  () =>
    import("../components/newLandingPages/newProductPage/components/Footer"),
);

const NewLandingPage: React.FC = () => {
  const [showbox, setShowBox] = useState<boolean>(true);
  usePageMeta({
    title: PLATFORM_DEFAULT_TITLE,
    description: PLATFORM_META_DESCRIPTION,
    canonicalPath: "/",
  });
  useJsonLdFaq();

  return (
    <>
      {/* {showbox && <CloudXBanner setShowBox={setShowBox} />} */}
      {/* WARNING: Required for CloudWatch RUM landing page analytics. Do not remove this component <LandingPageRumTracker /> */}
      <LandingPageRumTracker />
      <HomepageSeoNav />
      <Navbar showbox={showbox} />
      <AiShippingSection />
      <Suspense fallback={null}>
        <InvestorsSection />
      </Suspense>
      <Suspense fallback={null}>
        <ContinuousGovernanceSection />
      </Suspense>
      <Suspense fallback={null}>
        <VibeCodersSection />
      </Suspense>
      <Suspense fallback={null}>
        <GithubAppSection />
      </Suspense>
      <Suspense fallback={null}>
        <ArchitecturalDiagrams />
      </Suspense>
      <Suspense fallback={null}>
        <InfraDiagrams />
      </Suspense>
      <Suspense fallback={null}>
        <Service />
      </Suspense>
      <Suspense fallback={null}>
        <SupportedTools />
      </Suspense>
      <Suspense fallback={null}>
        <AutoGeneratedArchitecture showbox={showbox} />
      </Suspense>
      <Suspense fallback={null}>
        <FAQ />
      </Suspense>
      <Suspense fallback={null}>
        <SubscribeSection />
      </Suspense>
      <ScrollToTop />
      <div style={{ background: "#0B0D15" }}>
        <img
          src={light_curve}
          alt="light_curve"
          style={{ width: "100%" }}
          loading="lazy"
          decoding="async"
        />
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </div>
    </>
  );
};

export default NewLandingPage;
